import { API_URLS } from "../../constants/apiUrls";
import { commonFetch } from "../commonFetch";

export const ThemeinsertAndUpdate = async (payload) => {
  return commonFetch(`${API_URLS.THEME_INSERT_AND_UPDATE}`, {
    method: 'POST',
    body: payload,
    requiresAuth: true,
  });
};

export const GetThemeDetails = async (SchoolID) => {
  return commonFetch(`${API_URLS.GETALL_THEME_DETAILS}?schoolId=${SchoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};